module.exports = __webpack_public_path__ + "static/media/016-online-service.a9dff1d3.svg";